import { Navigate, Outlet } from 'react-router-dom';
import { usePortal } from '../../contexts/PortalContext';

export default function PortalProtectedRoute() {
  const { isAuthenticated, isLoading } = usePortal();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" replace />;
  }

  return <Outlet />;
}
